import { getItemFromLocalStorage } from '@/utils/localStorage';
import { SwapState } from './types';

export const LOCALSTORAGE_KEYS = {
  SWAP_SETTING: 'swap-setting',
};

export const storagedSwapSetting: SwapState['swapSettingMenu'] =
  getItemFromLocalStorage(LOCALSTORAGE_KEYS.SWAP_SETTING);
